if (!customElements.get('waitlist-form')) {
    class WaitlistForm extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('submit', this.#onSubmit);
        }

        #onSubmit = (event) => {
            event.preventDefault();

            const elForm = event.target.closest('form') ?? this.querySelector('form');
            const elEmail = this.querySelector('[data-email]');
            const elSubscribe = this.querySelector('[data-subscribe]');
            const elMessage = this.querySelector('[data-message]');

            this.postWaitlistData(elForm, elEmail)
                .then((result) => {
                    if (!result.ok) {
                        this.classList.add('error');
                        if (elMessage) {
                            elMessage.innerHTML = this.getAttribute('error-message');
                        }
                    } else {
                        this.classList.add('success');
                        if (elMessage) {
                            elMessage.innerHTML = this.getAttribute('success-message');
                        }
                    }

                    if (elSubscribe?.checked) {
                        this.postSubscribeData(elEmail).catch((error) => {
                            console.error(error);
                        });
                    }

                    setTimeout(() => this.resetFormUi(elEmail, elMessage), 10000);
                })
                .catch((error) => {
                    console.error(error);
                    this.classList.add('error');
                    if (elMessage) {
                        elMessage.innerHTML = this.getAttribute('error-message');
                    }
                    setTimeout(() => this.resetFormUi(elEmail, elMessage), 10000);
                });
        };

        async postWaitlistData(elForm, elEmail) {
            const email = elEmail?.value?.trim();
            const variantId = this.getAttribute('variant-id');
            const apiKey = this.getAttribute('api-key');
            const action = elForm?.getAttribute('action')
                || `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${apiKey}`;

            return fetch(action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    revision: '2024-06-15',
                },
                body: JSON.stringify({
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: { email },
                                },
                            },
                            channels: ['EMAIL'],
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: 'catalog-variant',
                                    id: `$shopify:::$default:::${Number(variantId)}`,
                                },
                            },
                        },
                    },
                }),
            });
        }

        async postSubscribeData(elEmail) {
            const email = elEmail?.value?.trim();
            const apiKey = this.getAttribute('api-key');
            const listId = this.getAttribute('list-id');

            if (!email || !apiKey || !listId) {
                return;
            }

            const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${apiKey}`, {
                method: 'POST',
                headers: {
                    revision: '2024-07-15',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: 'waitlist',
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: { email },
                                },
                            },
                        },
                        relationships: {
                            list: {
                                data: { type: 'list', id: listId },
                            },
                        },
                    },
                }),
            });

            if (!response.ok) {
                throw new Error(`Klaviyo list subscribe failed: ${response.status}`);
            }

            return response;
        }

        resetFormUi(elEmail = this.querySelector('[data-email]'), elMessage = this.querySelector('[data-message]')) {
            if (elEmail) {
                elEmail.value = '';
            }

            if (elMessage) {
                elMessage.innerHTML = '';
            }

            this.classList.remove('error');
            this.classList.remove('success');
        }
    }

    customElements.define('waitlist-form', WaitlistForm);
}
